export default "__VITE_ASSET__Dy2rOhnR__"